import { MetaStylePdpLink } from '../components/MetaStylePdpLink';
import { useMetaStylePdpLinkService } from '../services/useMetaStylePdpLinkService';

export const MetaStylePdpLinkContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { isHide, shop_department, onClickMetaStyle } = useMetaStylePdpLinkService();
  if (isHide) {
    return null;
  }
  return <MetaStylePdpLink shop_department={shop_department} onClick={onClickMetaStyle} />;
};
